import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import keys from '../../../../assets/translation-keys.json';
import { AuthRESTService } from '../../services/rest/auth-rest.service';
import Commons from '../../pages/commons';
import { forkJoin } from 'rxjs';
import { flatten, concat } from 'lodash';
import { Debounce } from 'lodash-decorators';
import { AppWidgetModule } from 'app/components/widgets/widget.module';
import { BpaExternalModule } from 'bpa_client_src/app/bpa-external.module';
import { SharedModule } from 'app/shared.module';

@Component({
  standalone: true,
  imports: [AppWidgetModule, BpaExternalModule, SharedModule],
  selector: 'Translation',
  templateUrl: './translation.component.html',
})
export class TranslationComponent extends Commons implements OnInit {
  public languages: string[] = [];
  public keys: string[];
  public initialKeys: string[];
  public searchKeys: string[];
  public dynamicMetaKeys: string[] = [
    'configure_registration_form.tooltipMessage_<lang>',
    'configure_registration_form.placeholder_<lang>',
  ];
  public translations: any = {};
  public originalTranslations: any = {};
  public searchTerm: string = '';

  constructor(
    private rest: AuthRESTService,
    private route: ActivatedRoute,
    toastr: ToastrService,
    translate: TranslateService
  ) {
    super(toastr, translate);
    this.initialKeys = keys.slice();
    this.keys = keys.slice();
    this.searchKeys = keys.slice();
  }

  public ngOnInit() {
    this.loadData();
  }

  private loadData() {
    this.languages = this.translate.getLangs();
    this.rest.get('cas/translations/allcodes').subscribe((res: string[]) => {
      this.translate.addLangs(res);
      this.keys = concat(
        this.initialKeys,
        flatten(
          res.map((langCode) => {
            return this.dynamicMetaKeys.map((dynamicKey) => {
              return dynamicKey.replace('<lang>', langCode);
            });
          })
        )
      );
      this.getAllTranslations();
    });
  }

  private getAllTranslations() {
    let restCalls = [];
    this.languages.splice(this.languages.indexOf('en'), 1);
    this.languages.sort((a, b) => {
      return a.localeCompare(b);
    });
    this.languages.unshift('en');
    this.languages.forEach((lang) => {
      restCalls.push(this.rest.get('cas/translations/' + lang));
    });
    forkJoin(restCalls).subscribe(
      (results) => {
        results.forEach((data, i) => {
          if (!Object.keys(data).length) {
            data = JSON.parse(JSON.stringify(this.originalTranslations['en']));
          }
          this.originalTranslations[this.languages[i]] = data;
          this.translations[this.languages[i]] = JSON.parse(
            JSON.stringify(data)
          );
        });
      },
      (err) => this.errorHandler(err)
    );
  }

  @Debounce(100)
  public translationKeysBySearch() {
    if (!this.searchTerm) {
      this.searchKeys = this.keys.slice();
      return;
    }
    this.searchKeys = this.keys.filter((key) => {
      if (
        key.toLocaleLowerCase().search(this.searchTerm.toLocaleLowerCase()) !==
        -1
      ) {
        return true;
      }
      return this.languages.some((l) => {
        const value = this.translations[l][key];
        if (!value) return;
        if (
          value
            .toLocaleLowerCase()
            .search(this.searchTerm.toLocaleLowerCase()) !== -1
        ) {
          return true;
        }
      });
    });
  }

  onTranslationBlur(lang: string, key: string) {
    if (this.originalTranslations[lang][key] === this.translations[lang][key]) {
      return;
    }

    this.rest
      .post(
        'translations',
        { code: lang, content: this.translations[lang] },
        { observe: 'response', responseType: 'text' }
      )
      .subscribe(
        (response) => {
          this.addSuccess('general.saved');
        },
        (err) => this.errorHandler(err)
      );
  }

  onLangsChange(ev) {
    this.searchTerm = null;
    this.loadData();
  }
}
